import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';

export const PromoTable = styled.table`
  position: absolute;
  inset: 0;
  height: 100%;
`;

export const OverlayDiv = styled.div`
  padding: 10px;
  position: absolute;
  inset: 0;
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const HeaderBox = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 32px;

  .analytics_header {
    width: 100%;
  }

  .analytics_tt_container,
  &::after {
    display: none;
  }

  &:hover .analytics_tt_container,
  &:hover::after {
    display: block;
  }

  &::after {
    content: ' ';
    width: 100%;
    position: absolute;
    height: 50px;
    bottom: 0;
  }

  .analytics_tt_container {
    position: absolute;
    bottom: calc(100% + 13px);
    z-index: 10;

    &::after {
      content: ' ';
      background: #020203;
      width: 10px;
      height: 10px;
      position: absolute;
      bottom: -5px;
      transform: rotate(45deg);
      left: 153px;
    }
  }

  .analytics_tt {
    position: relative;
    background: #020203;
    color: white;
    padding: 12px;
    font-size: 12px;
    width: 300px;
    border-radius: 6px;
    box-shadow: rgba(12, 13, 13, 0.15) 0px 0.125rem 0.25rem;
    text-wrap: wrap;
    white-space: break-spaces;
    text-align: left;
    text-transform: none;

    h2 {
      color: white;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
    }

    .action {
      display: flex;
      justify-content: right;

      a,
      button {
        margin-top: 20px;
        color: #020203;
      }
    }
  }
`;
